import { observer } from 'mobx-react';
import * as React from 'react';
import { store } from 'Models/Store';
import axios from 'axios';
import { SERVER_URL } from 'Constants';
import { NewModal } from 'Views/Components/Modal/NewModal';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';
import { Button, Colors, Display, Sizes } from 'Views/Components/Button/Button';
import { useQuery } from '@tanstack/react-query';

export const OutdatedAppModal = observer((props: any) => {
	const isOpen =
		!store.configuration.disableOutdatedAppModal &&
		(store.hasServerVersionMismatch ||
			(store.isStaff && store.userData?.lastSeenVersion !== store.buildVersion.version));
	const url = store.configuration.knowledgeBaseLink;
	const newUrl = new URL(url);
	newUrl.searchParams.set('redirect', '/releases/latest');
	const finalUrl = newUrl.toString();
	const { isLoading } = useQuery({
		queryKey: ['app-version', store.isStaff, isOpen, store.buildVersion.version],
		retry: false,
		queryFn: async () => {
			if (store.isStaff && isOpen) {
				await axios.post(`${SERVER_URL}/api/account/last-seen-version/${store.buildVersion.version}`);
			}
			return null;
		},
	});

	return (
		<NewModal className="version-modal__container" isOpen={isOpen} label="Server Version Updated">
			<div className="version-modal__body">
				<Icon name="warning" />
				<div className="version-modal__content">
					<h5>We&apos;ve released a new version 🎉</h5>
					<p>
						Your page will be refreshed to apply the update.
						{store.isStaff && (
							<>
								{' '}
								Please see{' '}
								<a href={finalUrl} target="_blank" rel="noreferrer">
									here
								</a>{' '}
								for our latest release information.
							</>
						)}
					</p>
				</div>
			</div>
			<Button
				onClick={() => window.location.reload()}
				colors={Colors.Secondary}
				display={Display.Solid}
				sizes={Sizes.Medium}
				disabled={isLoading}
			>
				Okay
			</Button>
		</NewModal>
	);
});
